<template>
    <div class="login">
        <template v-if="showLogin">
            <Header hideAll border></Header>
            <div class="content"  v-if="isPc">
                <img src="/static/img/logo-login.png" alt="" class="bg">
                <div class="form">
                    <div class="top">
                        欢迎使用
                    </div>
                    <p class="info">输入手机号，快速开始创建面试</p>
                    <el-form :model="form" :rules="rules" ref="form" class="login-form"  @submit.native.prevent>
                        <el-form-item prop='mobile'>
                            <el-input v-model="form.mobile" placeholder="手机号" />
                        </el-form-item>
                        <div class="row">
                            <div class="left">
                                <el-form-item prop="code">
                                    <el-input v-model="form.code" @keyup.enter.native="validate" placeholder="验证码" />
                                </el-form-item>
                            </div>
                            <div class="code">
                                <el-button plain class="btn" type="primary" :loading="loading" @click="getCode" v-if="seconds == 60">获取验证码</el-button>
                                <el-button class="get-code" disabled  v-else>{{seconds}}s</el-button>
                            </div>
                        </div>
                        <el-button type="primary" style="width: 100%" @click="validate">登录</el-button>
                    </el-form>
                </div>
            </div>
            <div class="only-pc"  v-if="!isPc">
                <!--
                <only-pc></only-pc>
                -->
            </div>
        </template>
        <template v-else>
            <div class="login-loading">
                <Header hideAll border></Header>
                <div class="loading-content">
                    <div class="loading-box">
                        <p class="box-title">欢迎使用海纳视频面试</p>
                        <p class="box-loading"><i class="el-icon-loading"></i>跳转官网中...</p>
                        <p class="box-tip">也可点击下方链接直接跳转</p>
                        <a href="https://www.hinapower.cn" class="box-url">www.hinapower.cn</a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import Header from '@/components/AiHeader'
    import toolkit from '@/util/toolkit'
    import OnlyPc from "@/content/onlyPc.vue"
    import config from '@/util/config'
    export default {
        components: {
            Header,
            OnlyPc
        },
        data(){
            return{
                form: {
                    mobile: '',
                    code: ''
                },
                rules: {
                    mobile: [{required: true, message: '请输入手机号', trigger: 'change'}],
                    code: [{required: true, message: '请输入验证码', trigger: 'change'}],
                },
                sendF: {},
                seconds: 60,
                loading: false,
                isPc: toolkit.isPc(),
                showLogin: false
            }
        },
        created(){
            document.title = '海纳：登录-大规模视频面试专业服务商'
        },
        beforeDestroy(){
            document.title = '海纳视频面试'
        },
        mounted(){
            if (!this.isPc) {
                location.href = 'https://www.hinapower.cn'
                return
            } else {
                setTimeout(() => {
                    location.href = 'https://www.hinapower.cn'
                }, 3000);
            }
        },
        methods: {
            getRouteInfo(){
                let phone = this.$route.query.phone
                if(phone){
                    this.form.mobile = phone
                }
            },
            getCode(){
                this.loading = true
                let source = this.$route.query.source
                toolkit.sendMsg(this.form.mobile, source).then(res => {
                    if(res.code == 0){
                        var timing = setInterval(()=>{
                            this.seconds = this.seconds - 1
                            if(!this.seconds){
                                this.seconds = 60
                                clearInterval(timing)
                            }
                        }, 1000)
                    }else{
                        this.$message.error(res.message)
                    }
                }).finally(()=>{
                    this.loading = false
                })
            },
            login(){
                let params = {
                    phone: this.form.mobile,
                    captcha: this.form.code
                }
                if(this.$route.query.source){
                    params.source = this.$route.query.source
                }
                toolkit.post('/interview/login/login', params).then(res => {
                    if(res.code == 0){
                        let user = res.data
                        user.id = user.userId
                        this.afterLogin(res.data)
                        // AI视频面试官网登录判断
                        let fromSource = this.$route.query.fr
                        if (fromSource === 'aihome') {
                            this.$router.push('/exam/paper?back=7&fr=aihome')
                        } else {
                            this.$router.push('/content')
                        }
                    }else{
                        this.$message.error(res.message)
                    }
                }).catch(err=>{
                    console.log(err, 'err')
                    this.$message.error('登录失败')
                })
            },
            validate(){
                this.$refs['form'].validate(valid => {
                    if(valid){
                        this.login()
                    }
                })
            },
            afterLogin(data){
                toolkit.setToken(data.token)
                toolkit.getUserInfo(user => {
                    this.$store.commit('updateUser', user)
                })
            },
        }
    }
</script>
<style scoped lang="scss">
.login {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 600px;
        position: relative;
        .bg {
            position: absolute;
            top: 250px;
            left: 50%;
            width: 1440px;
            height: auto;
            transform: translate(-50%, 0);
        }
        .form {
            width: 600px;
            height: 400px;
            font-size: 13px;
            background: rgba(255,255,255,1);
            box-shadow: 0px 2px 4px 0px rgba(62,68,76,0.1);
            border-radius: 6px;
            z-index: 666;
            .top {
                height: 58px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #3e444c;
                font-size: 18px;
                font-weight: bold;
                border-bottom: 1px solid #ececed;
                flex-direction: column;
            }
            .info{
                color: $c1;
                width: 100%;
                text-align: center;
                margin-top: 40px;
                font-size: 16px;
            }
            .login-form {
                padding: 20px 120px;
                .row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    .left {
                        flex: 1;
                        margin-right: 10px;
                        .el-form-item {
                            margin-bottom: 0;
                        }
                    }
                    .code {
                        width: 120px;
                        .el-button {
                            width: 100%;
                            font-size: 13px;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
    .only-pc{
        position: fixed;
        z-index: 999;
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
    }
    .login-loading {
        width: 100%;
        height: 100%;
        .loading-content {
            width: 100%;
            height: calc(100% - 55px);
            display: flex;
            justify-content: center;
            align-items: center;
            .loading-box {
                width: 400px;
                padding: 20px 20px 40px;
                margin-bottom: 140px;
                box-shadow: 0 2px 4px 0 rgba(62, 68, 76, 0.1);
                border: 1px solid #ccc;
                border-radius: 6px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .box-title {
                    font-size: 24px;
                    font-weight: bold;
                    line-height: 36px;
                }
                .box-url {
                    text-decoration: none;
                }
            }
            .el-icon-loading {
                margin-right: 10px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/content/login.vue